import React from 'react'

const PlaceOrder = () => <div>{/*<img alt="cataloge" src={`${require('../../assets/ZadigCatalogue.jpg')}`} />*/}</div>

export default PlaceOrder
